/* ===========================================================================
   HB DECK COMPANION  -  assets/hb-companion.js
   A collapsed rail on the left of Magic collection pages. It watches what the
   visitor opens and what lands in their cart, then suggests cards that real
   decklists run alongside those picks - filtered to what is actually on the
   shelf, at the live price.

   Data, all of it already on this site:
     decks.json          1,018 real decklists (MTGJSON) + shared name dictionary
     stock.json          normalised card name -> [title, price, handle, qty]
     hb-card-flags.json  name -> [comboCount] or [comboCount, isGameChanger]

   No AI service, no API key, no server. The flags file records HOW MANY known
   combos a card appears in, not WHICH cards it combos with, so the copy never
   claims a specific pairing.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__hbCompanion) return;
  window.__hbCompanion = 1;

  var SEEN_KEY  = 'hb_companion_seen_v2';
  var OPEN_KEY  = 'hb_companion_open_v1';
  var MAX_SEEN  = 20;
  var SHOW_STEP = 8;

  var BASIC = { 'plains':1,'island':1,'swamp':1,'mountain':1,'forest':1,'wastes':1,
                'snow covered plains':1,'snow covered island':1,'snow covered swamp':1,
                'snow covered mountain':1,'snow covered forest':1 };

  function norm(s){ return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g,' ').trim(); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }
  function money(n){ var v = Number(n); if (!isFinite(v)) return ''; return '$' + v.toFixed(2); }
  function cardName(t){ t = String(t || ''); var i = t.indexOf(' ['); return (i > -1 ? t.slice(0, i) : t).trim(); }

  /* Cards proven sold out by a live lookup. stock.json is a periodic export, so a
     card can sell between exports - this is the runtime correction. */
  var DEAD = {};
  var D = { decks:null, names:null, idx:null, stock:null, flags:null, state:0 }; /* 0 idle 1 loading 2 ready 3 failed */
  var S = { cart:[], seen:[], sugg:[], shown:SHOW_STEP, deckHits:0, built:false, open:false };

  /* ---------------------------------------------------------------- storage */
  function readSeen(){
    try { var a = JSON.parse(localStorage.getItem(SEEN_KEY)); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function writeSeen(a){ try { localStorage.setItem(SEEN_KEY, JSON.stringify(a.slice(0, MAX_SEEN))); } catch (e) {} }
  function pushSeen(name){
    name = cardName(name);
    if (!name) return false;
    var k = norm(name), a = readSeen();
    if (a.length && norm(a[0]) === k) return false;
    a = a.filter(function (x) { return norm(x) !== k; });
    a.unshift(name);
    writeSeen(a);
    S.seen = a.slice(0, MAX_SEEN);
    return true;
  }

  /* ------------------------------------------------------------------- data */
  function loadData(){
    if (D.state === 2) return Promise.resolve(true);
    if (D.state === 3) return Promise.resolve(false);
    if (D._p) return D._p;
    D.state = 1;
    var j = function (u, fb) {
      return fetch(u, { headers: { accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () { return fb; });
    };
    D._p = Promise.all([
      j(window.HB_DECKS_URL, null),
      j(window.HB_STOCK_URL, null),
      j(window.HB_FLAGS_URL, { flags: {} })
    ]).then(function (r) {
      if (!r[0] || !r[0].decks || !r[1] || !r[1].idx) { D.state = 3; return false; }
      D.decks = r[0].decks;
      D.names = r[0].names || [];
      D.stock = r[1].idx;
      D.flags = (r[2] && r[2].flags) || {};
      D.idx = {};
      for (var i = 0; i < D.names.length; i++) D.idx[norm(D.names[i])] = i;
      D.state = 2;
      return true;
    });
    return D._p;
  }

  function loadCart(){
    return fetch('/cart.js', { headers: { accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        S.cart = (c.items || []).map(function (i) { return cardName(i.product_title || i.title); })
                                .filter(Boolean);
        return S.cart;
      })
      .catch(function () { S.cart = []; return S.cart; });
  }

  /* ------------------------------------------------------------------ score */
  function compute(){
    var seeds = {}, i, j, k;
    for (i = 0; i < S.cart.length; i++) seeds[norm(S.cart[i])] = 3;
    for (i = 0; i < S.seen.length; i++) {
      k = norm(S.seen[i]);
      if (!seeds[k]) seeds[k] = Math.max(0.8, 2 - i * 0.09);
    }

    var seedIds = {}, anySeed = false, inCart = {};
    for (k in seeds) if (seeds.hasOwnProperty(k)) {
      var id = D.idx[k];
      if (id !== undefined) { seedIds[id] = seeds[k]; anySeed = true; }
    }
    for (i = 0; i < S.cart.length; i++) inCart[norm(S.cart[i])] = 1;

    var score = {}, cnt = {}, hits = 0;
    if (anySeed) {
      for (i = 0; i < D.decks.length; i++) {
        var kk = D.decks[i].k, w = 0, n = kk.length;
        for (j = 0; j < n; j++) { var sw = seedIds[kk[j][0]]; if (sw) w += sw; }
        if (!w) continue;
        hits++;
        var nf = w * (28 / Math.max(28, n));
        for (j = 0; j < n; j++) {
          var id2 = kk[j][0];
          if (seedIds[id2] !== undefined) continue;
          score[id2] = (score[id2] || 0) + nf;
          cnt[id2] = (cnt[id2] || 0) + 1;
        }
      }
    }
    S.deckHits = hits;

    var out = [];
    for (var sid in score) if (score.hasOwnProperty(sid)) {
      var nm = D.names[sid], key = norm(nm);
      if (!nm || BASIC[key] || inCart[key] || DEAD[key]) continue;
      var st = D.stock[key];
      if (!st || !st[2]) continue;
      var f = D.flags[key] || null,
          combos = f ? (f[0] || 0) : 0,
          gc = f ? !!f[1] : false,
          s = score[sid];
      if (combos) s *= 1 + Math.min(combos, 25) / 25 * 0.55;
      if (gc) s *= 1.18;
      out.push({ name: st[0] || nm, key: key, price: st[1], handle: st[2], qty: st[3] || 0,
                 s: s, decks: cnt[sid] || 0, combos: combos, gc: gc, fallback: false });
    }
    out.sort(function (a, b) { return b.s - a.s; });

    /* Nothing to go on yet - lead with the cards that appear in the most known
       combos and are genuinely on the shelf. Honest, and a decent shop window. */
    if (!out.length) {
      var pool = [];
      for (var fk in D.flags) if (D.flags.hasOwnProperty(fk)) {
        if (BASIC[fk] || inCart[fk] || DEAD[fk]) continue;
        var s2 = D.stock[fk];
        if (!s2 || !s2[2]) continue;
        var ff = D.flags[fk];
        pool.push({ name: s2[0] || fk, key: fk, price: s2[1], handle: s2[2], qty: s2[3] || 0,
                    s: (ff[0] || 0) + (ff[1] ? 8 : 0), decks: 0, combos: ff[0] || 0,
                    gc: !!ff[1], fallback: true });
      }
      pool.sort(function (a, b) { return b.s - a.s; });
      out = pool.slice(0, 40);
    }

    S.all  = out;
    S.sugg = out.slice(0, 40);
    return S.sugg;
  }

  function reasonFor(c){
    if (c.fallback) {
      if (c.gc && c.combos) return 'Game Changer &middot; in ' + c.combos + ' known combos';
      if (c.combos) return 'Appears in ' + c.combos + ' known combos';
      return 'On the shelf now';
    }
    var bits = [];
    bits.push('Runs with your picks in ' + c.decks + (c.decks === 1 ? ' deck' : ' decks'));
    if (c.gc) bits.push('Game Changer');
    else if (c.combos >= 3) bits.push(c.combos + ' known combos');
    return bits.join(' &middot; ');
  }

  /* --------------------------------------------------------------------- ui */
  var el = {};

  function build(){
    if (S.built) return;
    S.built = true;
    var root = document.createElement('div');
    root.className = 'hbco';
    root.innerHTML =
      '<button class="hbco__tab" type="button" aria-expanded="false">' +
        '<span class="hbco__tablabel">Deck helper</span>' +
        '<span class="hbco__badge" hidden>0</span>' +
      '</button>' +
      '<aside class="hbco__panel" role="dialog" aria-label="Deck helper" hidden>' +
        '<div class="hbco__head">' +
          '<div><p class="hbco__title">Goes with what you’re collecting</p>' +
          '<p class="hbco__basis"></p></div>' +
          '<button class="hbco__x" type="button" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="hbco__body"><ul class="hbco__list"></ul>' +
          '<button class="hbco__more" type="button" hidden>Show more</button>' +
        '</div>' +
        '<div class="hbco__foot">' +
          '<span class="hbco__note">Built from 1,018 real decklists. Only cards we have in stock.</span>' +
          '<button class="hbco__reset" type="button">Reset</button>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(root);

    el.root  = root;
    el.tab   = root.querySelector('.hbco__tab');
    el.badge = root.querySelector('.hbco__badge');
    el.panel = root.querySelector('.hbco__panel');
    el.basis = root.querySelector('.hbco__basis');
    el.list  = root.querySelector('.hbco__list');
    el.more  = root.querySelector('.hbco__more');

    el.tab.addEventListener('click', function () { toggle(!S.open); });
    root.querySelector('.hbco__x').addEventListener('click', function () { toggle(false); });
    el.more.addEventListener('click', function () { S.shown += SHOW_STEP; render(); });
    root.querySelector('.hbco__reset').addEventListener('click', function () {
      writeSeen([]); S.seen = []; S.shown = SHOW_STEP; refresh();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && S.open) toggle(false); });

    el.list.addEventListener('click', function (e) {
      var b = e.target.closest('.hbco__add');
      if (!b) return;
      e.preventDefault();
      addToCart(b);
    });
  }

  function toggle(open){
    S.open = !!open;
    el.panel.hidden = !S.open;
    el.root.classList.toggle('is-open', S.open);
    el.tab.setAttribute('aria-expanded', S.open ? 'true' : 'false');
    try { localStorage.setItem(OPEN_KEY, S.open ? '1' : '0'); } catch (e) {}
    if (S.open) { el.badge.hidden = true; ensure(); }
  }

  function render(){
    var list = S.sugg.slice(0, S.shown), i;
    if (!list.length) {
      el.list.innerHTML = '<li class="hbco__empty">Open a few cards and we’ll start suggesting things that play with them.</li>';
      el.more.hidden = true;
      return;
    }
    var html = '';
    for (i = 0; i < list.length; i++) {
      var c = list[i];
      html += '<li class="hbco__item" data-key="' + esc(c.key) + '">' +
        '<a class="hbco__thumb" href="/products/' + esc(c.handle) + '" data-h="' + esc(c.handle) + '"><span class="hbco__ph"></span></a>' +
        '<div class="hbco__meta">' +
          '<a class="hbco__name" href="/products/' + esc(c.handle) + '">' + esc(c.name) + '</a>' +
          '<p class="hbco__why">' + reasonFor(c) + '</p>' +
          '<p class="hbco__buy"><span class="hbco__price">' + money(c.price) + '</span>' +
            (c.qty ? '<span class="hbco__qty">' + c.qty + ' in stock</span>' : '') +
          '</p>' +
        '</div>' +
        '<button class="hbco__add" type="button" data-h="' + esc(c.handle) + '">Add</button>' +
      '</li>';
    }
    el.list.innerHTML = html;
    el.more.hidden = S.sugg.length <= S.shown;

    var basis = [];
    if (S.cart.length) basis.push(S.cart.length + (S.cart.length === 1 ? ' card in your cart' : ' cards in your cart'));
    if (S.seen.length) basis.push(S.seen.length + ' you’ve looked at');
    el.basis.innerHTML = basis.length
      ? esc('Based on ' + basis.join(' and ') + '.') + (S.deckHits ? ' Matched ' + S.deckHits + ' decklists.' : '')
      : 'Most-comboed cards we have on the shelf right now.';

    thumbs();
  }

  /* Thumbnails are fetched only for what is actually on screen. */
  var imgCache = {};
  function thumbs(){
    var nodes = el.list.querySelectorAll('.hbco__thumb[data-h]');
    Array.prototype.forEach.call(nodes, function (a) {
      var h = a.getAttribute('data-h');
      if (!h) return;
      a.removeAttribute('data-h');
      if (imgCache[h] === null) return;
      if (imgCache[h]) { paint(a, imgCache[h]); return; }
      fetch('/products/' + h + '.js', { headers: { accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          var li = a.closest('.hbco__item');
          var k  = li ? li.getAttribute('data-key') : null;
          /* Live truth beats the snapshot. */
          var alive = (p.variants || []).some(function (v) { return v.available; });
          if (!alive) {
            if (k) DEAD[k] = 1;
            if (li) li.remove();
            backfill();
            return;
          }
          var lp = null;
          (p.variants || []).forEach(function (v) {
            if (!v.available) return;
            var c = Number(v.price) / 100;
            if (isFinite(c) && (lp === null || c < lp)) lp = c;
          });
          if (lp !== null && li) {
            var pe = li.querySelector('.hbco__price');
            if (pe) pe.textContent = money(lp);
          }
          var u = p.featured_image || (p.images && p.images[0]) || '';
          if (typeof u !== 'string') u = (u && u.url) || '';
          imgCache[h] = u || null;
          if (u) paint(a, u);
        })
        .catch(function () { imgCache[h] = null; });
    });
  }
  /* When a live check kills a row, drop it from the ranked lists and re-render so
     the panel refills instead of showing a gap. DEAD only grows, so this settles. */
  var backfillT = null;
  function backfill(){
    clearTimeout(backfillT);
    backfillT = setTimeout(function () {
      S.sugg = S.sugg.filter(function (c) { return !DEAD[c.key]; });
      if (S.all) S.all = S.all.filter(function (c) { return !DEAD[c.key]; });
      render();
      highlight();
    }, 420);
  }

  function paint(a, url){
    var src = url.indexOf('?') > -1 ? url : url + '?width=160';
    a.innerHTML = '<img src="' + esc(src) + '" alt="" loading="lazy" width="52" height="73">';
  }

  /* ---------------------------------------------------------------- add */
  function addToCart(btn){
    var h = btn.getAttribute('data-h');
    if (!h || btn.disabled) return;
    var old = btn.textContent;
    btn.disabled = true; btn.textContent = '…';
    fetch('/products/' + h + '.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        if (!v) throw new Error('no variant');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'content-type': 'application/json', accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        btn.textContent = 'Added';
        btn.classList.add('is-done');
        bumpCartBubble();
        setTimeout(function () { refresh(); }, 450);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = old;
      });
  }

  function bumpCartBubble(){
    fetch('/cart.js', { headers: { accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        var b = document.querySelector('.cart-count-bubble span[aria-hidden], .cart-count-bubble span');
        if (b) b.textContent = n;
        var wrap = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (!wrap && n) {
          var icon = document.querySelector('#cart-icon-bubble');
          if (icon) {
            var d = document.createElement('div');
            d.className = 'cart-count-bubble';
            d.innerHTML = '<span aria-hidden="true">' + n + '</span>';
            icon.appendChild(d);
          }
        }
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------ highlights */
  var hiKeys = {};
  function highlight(){
    /* Highlight from the WHOLE candidate set, not the top 40. The panel shows
       the best few; the grid should light up any complementary card the visitor
       happens to scroll past, and on a 15,632-card collection a top-25 pool
       would essentially never intersect the 24 cards on screen. */
    var top = (S.all && S.all.length ? S.all : S.sugg).slice(0, 2000), i;
    hiKeys = {};
    for (i = 0; i < top.length; i++) hiKeys[top[i].key] = top[i];
    paintGrid();
  }
  function paintGrid(){
    var nodes = document.querySelectorAll('[data-hb-card]');
    Array.prototype.forEach.call(nodes, function (n) {
      var wrap = n.closest('.card-wrapper');
      if (!wrap) return;
      var hit = hiKeys[norm(n.getAttribute('data-hb-card'))];
      if (hit && !wrap.classList.contains('hbco-hit')) {
        wrap.classList.add('hbco-hit');
        if (!wrap.querySelector('.hbco-flag')) {
          var s = document.createElement('span');
          s.className = 'hbco-flag';
          s.textContent = hit.fallback ? 'Popular pick' : 'Plays with your cards';
          wrap.appendChild(s);
        }
      } else if (!hit && wrap.classList.contains('hbco-hit')) {
        wrap.classList.remove('hbco-hit');
        var f = wrap.querySelector('.hbco-flag');
        if (f) f.remove();
      }
    });
  }

  /* ----------------------------------------------------------------- toast */
  var toastEl = null, toastT = null;
  function toast(c){
    if (!c) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'hbco-toast';
      toastEl.hidden = true;
      document.body.appendChild(toastEl);
      toastEl.addEventListener('click', function (e) {
        if (e.target.closest('.hbco-toast__x')) { hideToast(); return; }
        if (e.target.closest('.hbco-toast__open')) { hideToast(); toggle(true); }
      });
    }
    toastEl.innerHTML =
      '<span class="hbco-toast__dot"></span>' +
      '<span class="hbco-toast__txt"><b>' + esc(c.name) + '</b> ' + reasonFor(c) + '</span>' +
      '<button class="hbco-toast__open" type="button">See picks</button>' +
      '<button class="hbco-toast__x" type="button" aria-label="Dismiss">&times;</button>';
    toastEl.hidden = false;
    requestAnimationFrame(function () { toastEl.classList.add('is-in'); });
    clearTimeout(toastT);
    toastT = setTimeout(hideToast, 9000);
  }
  function hideToast(){
    if (!toastEl) return;
    toastEl.classList.remove('is-in');
    clearTimeout(toastT);
    setTimeout(function () { if (toastEl && !toastEl.classList.contains('is-in')) toastEl.hidden = true; }, 320);
  }

  /* ------------------------------------------------------------- lifecycle */
  var busy = false;
  function refresh(afterAdd){
    if (busy) return Promise.resolve();
    busy = true;
    return loadData().then(function (ok) {
      if (!ok) { busy = false; return; }
      return loadCart().then(function () {
        S.seen = readSeen();
        compute();
        if (S.built) { render(); }
        highlight();
        var n = S.sugg.length;
        /* Badge only once there is something personal to go on - a first-time
           visitor would otherwise see "40" for the generic popular-picks list. */
        if (S.built && !S.open) {
          var personal = n && (S.cart.length || S.seen.length);
          el.badge.hidden = !personal;
          if (personal) el.badge.textContent = n > 40 ? '40+' : n;
        }
        if (afterAdd && S.sugg.length) toast(S.sugg[0]);
        busy = false;
      });
    }).catch(function () { busy = false; });
  }
  function ensure(){ if (D.state !== 2) refresh(); }

  /* Track opens: any click that heads to a product page on this grid. */
  function watchClicks(){
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="/products/"]');
      if (!a) return;
      var wrap = a.closest('.card-wrapper');
      var nameEl = wrap ? wrap.querySelector('[data-hb-card]') : null;
      var nm = nameEl ? nameEl.getAttribute('data-hb-card') : null;
      if (!nm) {
        var head = wrap ? wrap.querySelector('.card__heading a') : null;
        nm = head ? head.textContent.trim() : null;
      }
      if (nm && pushSeen(nm)) { setTimeout(function () { refresh(); }, 60); }
    }, true);
  }

  /* Watch every route into the cart, whoever fires it. */
  function watchCart(){
    var of = window.fetch;
    if (of && !of.__hbco) {
      var wrapped = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var p = of.apply(this, arguments);
        if (/\/cart\/(add|change|update)/.test(url)) {
          p.then(function (r) { if (r && r.ok) setTimeout(function () { refresh(true); }, 260); }).catch(function () {});
        }
        return p;
      };
      wrapped.__hbco = 1;
      window.fetch = wrapped;
    }
    var op = XMLHttpRequest.prototype.open;
    if (!op.__hbco) {
      var np = function (m, u) {
        this.__hbcoUrl = u;
        return op.apply(this, arguments);
      };
      np.__hbco = 1;
      XMLHttpRequest.prototype.open = np;
      var os = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        var self = this;
        this.addEventListener('load', function () {
          if (/\/cart\/(add|change|update)/.test(self.__hbcoUrl || '')) setTimeout(function () { refresh(true); }, 260);
        });
        return os.apply(this, arguments);
      };
    }
    document.addEventListener('cart:refresh', function () { refresh(); });
  }

  function watchGrid(){
    var g = document.querySelector('#product-grid');
    if (!g) return;
    var mo = new MutationObserver(function () { paintGrid(); });
    mo.observe(g, { childList: true, subtree: true });
  }

  function start(){
    if (!document.querySelector('#product-grid')) return;
    build();
    watchClicks();
    watchCart();
    watchGrid();
    S.seen = readSeen();
    try { if (localStorage.getItem(OPEN_KEY) === '1') toggle(true); } catch (e) {}

    /* Load the corpus once the page is quiet - it is ~700KB and must never
       compete with the card images for bandwidth. */
    var kick = function () { refresh(); };
    if ('requestIdleCallback' in window) requestIdleCallback(kick, { timeout: 2600 });
    else setTimeout(kick, 1400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
